/* Stickidy ürün sayfası v2 (3 Eki 2026, v57): görünüm yardımcıları. Sepet/varyant mantığına dokunmaz; stickidy-pdp.js ve tema akışı aynen çalışır.
   - sepete ekle düğmesine güncel fiyat (tema .product__price'ı izler)
   - sticker ölçü haplarına fiyat (snippet data-vp: varyant id → fiyat metni)
   - kaplama model seçicisine "sık seçilen" hapları (ilk 4 model; seçim = listedeki satıra tıklama)
   - galeri altına kesim açıklaması
   - fiyat yanına −% rozeti (snippet data-pct) */
(function () {
  'use strict';
  if (window.__stkPdpV2) return; window.__stkPdpV2 = true;
  var mid = document.querySelector('[data-stk-pd="mid"]');
  var cfg = window.StickidyPdp || {};
  function priceText() {
    var p = document.querySelector('.product__price .price');
    if (!p) return '';
    var s = p.querySelector('.price__sale') || p.querySelector('.price__item') || p.querySelector('.price__regular');
    return s ? s.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  /* sepete ekle fiyatı + −% rozeti + boş kart gizleme — tema varyant değişiminde fiyat/düğme bloklarını yeniden bastığı için her değişimde yeniden uygulanır */
  var pct = mid ? parseInt(mid.getAttribute('data-pct'), 10) || 0 : 0;
  function ensure() {
    var btn = document.querySelector('#product-container .product-form__submit');
    if (btn) {
      var em = btn.querySelector('.stk-bp');
      if (!em) { em = document.createElement('em'); em.className = 'stk-bp'; btn.appendChild(em); }
      var t = priceText(); em.textContent = t; em.hidden = !t || btn.disabled;
      em.style.display = ''; if (btn.scrollWidth > btn.clientWidth + 2) em.style.display = 'none';
    }
    var p = document.querySelector('.product__price .price');
    if (p && pct && !p.querySelector('.stk-pd__pct')) { var b = document.createElement('span'); b.className = 'stk-pd__pct'; b.textContent = '−%' + pct; p.appendChild(b); }
    // içeriği olmayan tema kartları (ör. boş ikon bloğu)
    document.querySelectorAll('product-info > .product-page__content-sidebar > .content-item').forEach(function (c) {
      var has = (c.innerText || '').trim() || c.querySelector('img,canvas,svg,input,button,iframe,video,select,textarea');
      if (has) c.removeAttribute('data-stk-empty'); else c.setAttribute('data-stk-empty', '1');
    });
  }
  ensure();
  var pi = document.querySelector('product-info'), tmr = 0;
  function sched() { clearTimeout(tmr); tmr = setTimeout(ensure, 60); }
  if (pi && 'MutationObserver' in window) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t && t.closest && (t.closest('.stk-bp') || (t.classList && t.classList.contains('stk-pd__pct')))) continue; sched(); return; }
  }).observe(pi, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input[type="radio"],select')) [100, 600, 1500].forEach(function (ms) { setTimeout(ensure, ms); }); });
  window.addEventListener('resize', sched);
  /* ölçü haplarına fiyat */
  (function () {
    if (!mid || cfg.kind === 'cover') return;
    var vp; try { vp = JSON.parse(mid.getAttribute('data-vp') || '{}'); } catch (e) { return; }
    function paint() {
      document.querySelectorAll('#variants-container .product-form__item input[type="radio"][data-variant-id]').forEach(function (r) {
        var l = r.nextElementSibling, t = vp[r.getAttribute('data-variant-id')];
        if (!l || !t || l.querySelector('.stk-vp')) return;
        var i = document.createElement('i'); i.className = 'stk-vp'; i.textContent = t; l.appendChild(i);
      });
    }
    paint();
    var vc = document.getElementById('variants-container');
    if (vc && 'MutationObserver' in window) new MutationObserver(function () { setTimeout(paint, 30); }).observe(vc, { childList: true, subtree: true });
  })();
  /* sık seçilen modeller */
  (function () {
    var md = mid ? mid.querySelector('[data-stk-model]') : null; if (!md) return;
    var rows = [].slice.call(md.querySelectorAll('[data-md-row]')).filter(function (r) { return r.getAttribute('data-av') === 'true'; }).slice(0, 4);
    if (rows.length < 2) return;
    var wrap = document.createElement('div'); wrap.className = 'stk-md__pop';
    var lab = document.createElement('span'); lab.textContent = 'Sık seçilen:'; wrap.appendChild(lab);
    var nameEl = md.querySelector('[data-md-name]');
    rows.forEach(function (r) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = r.getAttribute('data-v');
      b.addEventListener('click', function () { r.click(); });
      wrap.appendChild(b);
    });
    var btn = md.querySelector('[data-md-btn]'); btn.parentNode.insertBefore(wrap, btn.nextSibling);
    function sync() { var v = nameEl ? nameEl.textContent.trim() : ''; wrap.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', b.textContent === v); }); }
    sync();
    if (nameEl && 'MutationObserver' in window) new MutationObserver(sync).observe(nameEl, { childList: true, characterData: true, subtree: true });
  })();
  /* galeri altı açıklama */
  (function () {
    var mg = document.querySelector('media-gallery'); if (!mg || mg.querySelector('.stk-cap')) return;
    var t = mg.getAttribute('data-stk-cap') || (mid ? mid.getAttribute('data-cap') : ''); if (!t) return;
    var parts = t.split('|');
    var d = document.createElement('div'); d.className = 'stk-cap';
    var b = document.createElement('b'); b.textContent = parts[0].trim(); d.appendChild(b);
    var s = document.createElement('span'); s.textContent = (parts[1] || '').trim(); d.appendChild(s);
    mg.appendChild(d);
  })();
})();
